import { ICarouselPrincipal } from "@/types/app";
import { getImageUrl } from "@/utils/global";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useState } from "react";
import { isInternalLink } from "@/utils/linkValidator";
import ExternalLinkModal from "@/Components/modals/ExternalLinkModal";

const customStyles = `
    .premium-hero {
        padding-bottom: 40px !important;
    }
    .premium-hero .swiper-pagination-bullets {
        bottom: 0px !important;
    }
    .premium-hero .swiper-button-next,
    .premium-hero .swiper-button-prev {
        background-color: rgba(255, 255, 255, 0.9) !important;
        width: 44px !important;
        height: 44px !important;
        border-radius: 50% !important;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
        opacity: 0.8 !important;
        transition: all 0.3s ease !important;
    }
    .premium-hero:hover .swiper-button-next,
    .premium-hero:hover .swiper-button-prev {
        opacity: 1 !important;
    }
    .premium-hero .swiper-button-next::after,
    .premium-hero .swiper-button-prev::after {
        font-size: 20px !important;
        font-weight: 900 !important;
    }
    @media (max-width: 768px) {
        .premium-hero .swiper-button-next,
        .premium-hero .swiper-button-prev {
            width: 32px !important;
            height: 32px !important;
        }
        .premium-hero .swiper-button-next::after,
        .premium-hero .swiper-button-prev::after {
            font-size: 14px !important;
        }
        .premium-hero {
            padding-bottom: 30px !important;
        }
    }
    .premium-hero .swiper-pagination-bullet {
        width: 12px !important;
        height: 12px !important;
        margin: 0 5px !important;
        opacity: 0.4 !important;
        background: #790546 !important;
    }
    .premium-hero .swiper-pagination-bullet-active {
        opacity: 1 !important;
        transform: scale(1.3);
    }
`;

export default function Slider({ data }: { data: ICarouselPrincipal[] }) {
    const [externalLinkModalOpen, setExternalLinkModalOpen] = useState(false);
    const [pendingExternalUrl, setPendingExternalUrl] = useState<string>('');

    if (!data || data.length === 0) return null;

    const carouselData1 = data.filter((item) => item.nro_carousel === 1);

    const handleLinkClick = (url?: string | null) => {
        if (!url || url.trim() === "") return;
        const normalizedUrl = url.trim();
        if (isInternalLink(normalizedUrl)) {
            window.location.href = normalizedUrl;
        } else {
            setPendingExternalUrl(normalizedUrl);
            setExternalLinkModalOpen(true);
        }
    };

    const handleConfirmExternal = () => {
        if (pendingExternalUrl) window.location.href = pendingExternalUrl;
        setExternalLinkModalOpen(false);
        setPendingExternalUrl('');
    };

    return (
        <>
            <style>{customStyles}</style>
            {/* Contenedor sin fondo forzado, se mezclará perfecto con la página blanca */}
            <section className="w-full relative premium-hero bg-white">
                <Swiper
                    modules={[Autoplay, Navigation, Pagination, EffectFade]}
                    effect="fade"
                    fadeEffect={{ crossFade: true }}
                    spaceBetween={0}
                    slidesPerView={1}
                    navigation={true}
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 5500, disableOnInteraction: false }}
                    loop={carouselData1.length > 1}
                    autoHeight={true} /* AutoHeight permite adaptarlo al Flyer intacto */
                    className="w-full"
                    style={{
                        "--swiper-navigation-color": "#790546",
                        "--swiper-pagination-color": "#790546",
                    } as React.CSSProperties}
                >
                    {carouselData1.map((slider, index) => (
                        <SwiperSlide key={slider.id}>
                            <div
                                className="w-full cursor-pointer overflow-hidden block aspect-auto md:aspect-[21/9] relative"
                                onClick={() => handleLinkClick(slider.link)}
                            >
                                <img
                                    src={getImageUrl(slider.ruta)}
                                    // Respetamos 100% la foto original sin recortarla y sin fondo extra
                                    className="w-full h-full object-cover block mx-auto"
                                    loading={index === 0 ? "eager" : "lazy"}
                                    fetchPriority={index === 0 ? "high" : "auto"}
                                    alt={slider.nombre_promo || `Hero Banner ${slider.id}`}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>

            <ExternalLinkModal
                isOpen={externalLinkModalOpen}
                onClose={() => setExternalLinkModalOpen(false)}
                onConfirm={handleConfirmExternal}
                url={pendingExternalUrl}
            />
        </>
    );
}
